import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import { STATE_LAW_API } from "./apiRoutes";
import axiosAuth from "@/services/axiosAuth";

interface UseGetStateLawByIdProps {
  id: string;
  queryParams?: Omit<UseQueryOptions, "queryKey">
}

const getStateLawById = async (id: string) =>
  await axiosAuth.get(`${STATE_LAW_API}/${id}`);

const useGetStateLawById = ({id, queryParams}: UseGetStateLawByIdProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["state-law", id],
    queryFn: () => getStateLawById(id),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    ...queryParams,
  });
};

export default useGetStateLawById;
